import { Splash } from "@/components/common";
import { useAuth, useAuthRedirect } from "@/hooks";
import { SessionRecovery } from "../session-recovery";
import { Navigate } from "react-router-dom";

interface PublicRouteProps {
  children: React.ReactElement;
}

export function PublicRoute({ children }: PublicRouteProps) {
  const { accessToken, user, isLoading, sessionStatus, initialize, logoutError } = useAuth();
  const { redirectToSavedLocation } = useAuthRedirect();

  if (isLoading) {
    return <Splash />;
  }

  if (sessionStatus === "checking" || sessionStatus === "unavailable") {
    return <SessionRecovery blocked pending={sessionStatus === "checking"} onRetry={initialize} />;
  }

  if (accessToken && user) {
    const url = redirectToSavedLocation();
    return <Navigate to={url || "/"} replace />;
  }

  return <>
    {logoutError && <p role="alert" className="border-b border-app-border bg-accent-warm-soft p-4 text-sm text-app-fg">{logoutError}</p>}
    {children}
  </>;
}
